import React, { useEffect, useState } from 'react';
import { Input, List, Avatar } from 'antd';
import './history.css';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { UserOutlined, ConsoleSqlOutlined, } from '@ant-design/icons';
const { Search } = Input;

const HistoryPage = () => {
  const chatHistory = useSelector(state => {
    return state.chat.chatHistory.map(message => ({
      ...message,
      uuid: uuidv4()
    }));
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [hisMessages, setHisMessages] = useState([]);

  const messagesFromUser = chatHistory.filter(message => message.user === 'user');
  const filteredData = messagesFromUser.filter(item =>
    item.text.toLowerCase().includes(searchTerm.toLowerCase())
  );



  // 处理点击List中消息项的函数
  const handleListItemClick = (clickedItemUuid) => {
    const index = chatHistory.findIndex(item => item.uuid === clickedItemUuid);
    setHisMessages([chatHistory[index], chatHistory[index + 1]]);

  };

  const renderMessage = (message, index) => {
    const isUserMessage = message.user === 'user';
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 10 }}>
        {isUserMessage ? (
          <Avatar icon={<UserOutlined />} style={{ marginRight: 10 }} size="large" />
        ) : (
          <Avatar style={{ backgroundColor: 'blue', marginRight: 10 }} size="large"
            icon={<ConsoleSqlOutlined />} />
        )}
        <div key={index} className={isUserMessage ? 'user-chat' : 'other-chat'} style={{ marginBottom: 10, padding: 10, borderRadius: 10 }}>
          <div>
            <p style={{ margin: 0, fontSize: 16 }}>{message.text}</p>
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className='big-history'>
      <div className="history-container">
        <Search
          placeholder="search for..."
          onChange={e => setSearchTerm(e.target.value)}
          style={{ marginBottom: 20 }}
        />
        <List
          bordered
          dataSource={filteredData}
          renderItem={item => (
            <List.Item
              onClick={() => handleListItemClick(item.uuid)} // 点击时传递当前消息项的uuid
            >
              {item.text}
            </List.Item>
          )}
        />

      </div>
      <div className='history-right'>
        {hisMessages.length > 1 && <List
          dataSource={hisMessages}
          renderItem={(message, index) => renderMessage(message, index)}
        />
        }
      </div>
    </div>
  );
};

export default HistoryPage;